import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton  from 'material-ui/FlatButton';
import { localize } from 'react-localize-redux';
import style from './styles/ButtonLoaderStyles';

/**
 * usato per mostrare lo spinner di caricamento in list
 * @param {*} param0
 */
const ButtonLoader = ({ translate, currentLanguage }) => (
    <FlatButton
        disabled={true}
        style={style.button}
        icon={<CircularProgress size={25} style={style.icon} />}>
    </FlatButton >
);

export default localize(ButtonLoader, 'locale');


// WEBPACK FOOTER //
// ./src/components/loaders/ButtonLoader.js